module.exports = __webpack_public_path__ + "static/media/hs1.30a0c2b5.jpg";